import React, {
    createContext, useContext
} from 'react';
import useSWR from 'swr';
import { useAccount } from './authenticationProvider';
import { getJsonAsync } from '../services/fetchConfig';

const featureFlagRoute = '/configuration/featureFlags';

const FeatureFlagContext = createContext({});

export const FeatureFlagProvider = ({ children }) => {
  const { isAuthenticated, } = useAccount();
  const { data } = useSWR(isAuthenticated ? featureFlagRoute : null, getJsonAsync);

    const value = React.useMemo(() => {
    if (!data) return {};
    // Kinda cheeky, but basically packing the actual feature flags together with a
    // dummy feature flag whose job is to tell whether the other flags are loaded in
    return { ...data, featureFlagsLoaded: true };
  }, [data]);
  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlagsContext = () => useContext(FeatureFlagContext);

export const useFeatureFlag = (key) => {
  const ctx = useFeatureFlagsContext();
  return !!ctx[key];
};
